import { createReducer } from '@reduxjs/toolkit'
import { updateLevel } from './actions'

export interface Appmarket {
  level: string
}

const market: Appmarket = {
  level: localStorage.level || 'v3'
}

export default createReducer(market, builder => 
  builder
    .addCase(updateLevel, (state, action) => {
      const {level} = action.payload
      localStorage.setItem('level', level)
      state.level = level
    })
)